import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'

const pageHeader = css`
  background-color: ${variables.THEME_C};
  padding: 10px 0;
`
const title = css`
  color: ${variables.WHITE};
  font-size: 1.6rem;
  font-weight: 700;
  min-height: 24px;

  ${minMq('MD')} {
    font-size: 2.4rem;
    min-height: 36px;
  }
`

export const style = {
  pageHeader,
  title
}
